export const OPENAI_PROXY_BASE_PATH = '/api/openai/v1';
export const LLM_PROXY_BASE_PATH = '/api/llm/v1';
export const OPENAI_PROXY_AUTH_SENTINEL = '__ownyou_openai_proxy__';

export interface OpenAIRequestConfig {
  api_key?: string;
  base_url?: string;
}

export type LLMProxyProvider = 'openai' | 'anthropic' | 'claude' | 'groq' | 'deepinfra' | 'xai' | 'grok';

export function getOpenAIProxyBaseUrl(): string {
  const origin = globalThis.location?.origin ?? '';
  return `${origin}${OPENAI_PROXY_BASE_PATH}`;
}

export function getDirectOpenAIKey(): string | undefined {
  return undefined;
}

export function shouldUseOpenAIProxy(): boolean {
  return shouldUseLLMProxy();
}

export function shouldUseLLMProxy(): boolean {
  const hostname = globalThis.location?.hostname ?? '';
  return hostname === 'app.ownyou.app' || hostname.endsWith('.app-ownyou-app.pages.dev');
}

function canonicalProvider(provider: LLMProxyProvider | string): string {
  const lower = provider.toLowerCase();
  if (lower === 'claude') return 'anthropic';
  if (lower === 'grok') return 'xai';
  return lower;
}

export function getLLMProxyBaseUrl(provider: LLMProxyProvider | string): string {
  const origin = globalThis.location?.origin ?? '';
  return `${origin}${LLM_PROXY_BASE_PATH}/${canonicalProvider(provider)}`;
}

export function getLLMProxyRequestConfig(
  provider: LLMProxyProvider | string,
  privyAccessToken?: string | null,
): OpenAIRequestConfig {
  if (!shouldUseLLMProxy() || !privyAccessToken) return {};
  return {
    api_key: privyAccessToken,
    base_url: getLLMProxyBaseUrl(provider),
  };
}

export function getOpenAIRequestConfig(privyAccessToken?: string | null): OpenAIRequestConfig {
  const directKey = getDirectOpenAIKey();
  if (directKey) return { api_key: directKey };
  if (!shouldUseOpenAIProxy()) return {};
  if (!privyAccessToken) return {};
  return {
    api_key: privyAccessToken,
    base_url: getOpenAIProxyBaseUrl(),
  };
}

export function hasOpenAIProxyCredentials(config: OpenAIRequestConfig): boolean {
  return Boolean(config.api_key && config.base_url);
}
